import { readRecentLeads } from "@/features/leads/localStorage/leadStorage";

export default function RecentLeadsListQuery() {
  const recentLeads = readRecentLeads();

  return {
    recentLeads,
  };
}
